import React from 'react';
import { ChildSupportContent } from './ChildSupportContent';

export const ChildSupport = () => {
  return (
    <div className="child-support">
      <div className="child-support-heading">
        <p>СТЯГНЕННЯ АЛІМЕНТІВ</p>
      </div>
      <div className="service-packages">
        <div className="service-package">
          <div className="info-heading desktop">
            <p>
              ПАКЕТ <br />
              «МІНІМАЛЬНИЙ»
            </p>
          </div>
          <ChildSupportContent packageName="min" />
        </div>
        <div className="service-package">
          <div className="info-heading desktop">
            <p>
              ПАКЕТ «ПІД КЛЮЧ, <br />
              БЕЗ ВАШОЇ УЧАСТІ»
            </p>
          </div>
          <ChildSupportContent packageName="max" />
        </div>
        <div className="service-package">
          <div className="info-heading desktop">
            <p>
              ПАКЕТ <br />
              «ОПТИМАЛЬНИЙ»
            </p>
          </div>
          <ChildSupportContent packageName="mid" />
        </div>
      </div>
      <div className="info-price">
        <p>1000грн</p>
        <p>3500грн</p>
        <p>2000грн</p>
      </div>
    </div>
  );
};
